import { create } from 'zustand';

export interface Client {
  id: number;
  name: string;
  logo: string;
  industry: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  paymentTerms: string;
  projects: {
    id: number;
    name: string;
    status: 'In Progress' | 'Planning' | 'Completed';
    startDate: string;
    endDate: string;
  }[];
}

interface ClientStore {
  clients: Client[];
  selectedClient: Client | null;
  setSelectedClient: (id: number) => void;
}

const clientData: Client[] = [
  {
    id: 1,
    name: 'TechCorp Industries',
    logo: '🏢',
    industry: 'Technology',
    contactName: 'John Smith',
    contactEmail: 'john.smith@techcorp.com',
    contactPhone: '(555) 123-4567',
    paymentTerms: 'Net 30',
    projects: [
      {
        id: 1,
        name: 'Identity Federation Hub',
        status: 'In Progress',
        startDate: '2023-08-01',
        endDate: '2023-12-31'
      }
    ]
  },
  {
    id: 2,
    name: 'SecureBank Global',
    logo: '🏦',
    industry: 'Finance',
    contactName: 'Sarah Johnson',
    contactEmail: 'sarah.j@securebank.com',
    contactPhone: '(555) 234-5678',
    paymentTerms: 'Net 45',
    projects: [
      {
        id: 2,
        name: 'Zero Trust Implementation',
        status: 'Planning',
        startDate: '2023-09-01',
        endDate: '2024-03-31'
      }
    ]
  },
  {
    id: 3,
    name: 'Healthcare Plus',
    logo: '🏥',
    industry: 'Healthcare',
    contactName: 'Michael Chen',
    contactEmail: 'm.chen@healthcareplus.com',
    contactPhone: '(555) 345-6789',
    paymentTerms: 'Net 30',
    projects: [
      {
        id: 3,
        name: 'IAM System Upgrade',
        status: 'Completed',
        startDate: '2023-07-15',
        endDate: '2023-10-15'
      }
    ]
  }
];

export const useClientStore = create<ClientStore>((set) => ({
  clients: clientData,
  selectedClient: null,
  setSelectedClient: (id: number) => {
    const client = clientData.find(c => c.id === id);
    set({ selectedClient: client || null });
  }
}));